<template>
  <section class="grey_bg" aria-labelledby="faq-page-heading">
    <div class="container mt-4">
      <h1 id="faq-page-heading" class="display-1 text-center">
        <span class="heading_bdr_btm">
          Frequently Asked Questions
        </span>
      </h1>
      <h2 class="sr-only">Common questions about Grow With Stocks</h2>
      <faq-child></faq-child>
    </div>
  </section>
</template>

<script>
  import FaqChild from "../components/FaqChild.vue";

  export default {
    name: "Faq",
    components: {
      FaqChild
    }
  };
</script>

<style lang="scss">
  h3 {
    text-align: center;
  }
  // .heading_bdr_btm {
  //   padding-bottom: 5px;
  //   border-bottom: 3px #31cc9a solid;
  // }
  .grey_bg {
    background: #f7f7f7;
  }
  .sr-only {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }
</style>



// WEBPACK FOOTER //
// src/views/Faq.vue